/* PURPOSE — Hero Particle System */
(function() {
  function initParticles(section) {
    var ROWS = parseInt(section.getAttribute('data-particle-rows')) || 15;
    var TOTAL = ROWS * ROWS;
    var GAP = 1.8;
    var grid = section.querySelector('#particle-grid');
    var hero = section;
    if (!grid) return;

    var particles = [];
    var cursor = { x: 0, y: 0 }, staticCur = { x: 0, y: 0 };
    var isAuto = true, isStatic = false;
    var startTime = Date.now(), lastMove = Date.now();
    var raf, mTimer;

    grid.style.width  = (ROWS * GAP) + 'rem';
    grid.style.height = (ROWS * GAP) + 'rem';
    grid.innerHTML = '';

    for (var i = 0; i < TOTAL; i++) {
      var row = Math.floor(i / ROWS), col = i % ROWS;
      var cr = Math.floor(ROWS / 2), cc = Math.floor(ROWS / 2);
      var dist = Math.sqrt(Math.pow(row - cr, 2) + Math.pow(col - cc, 2));
      var scale = Math.max(0.1, 1.2 - dist * 0.12);
      var opacity = Math.max(0.04, 1 - dist * 0.1);
      var light = Math.max(14, 72 - dist * 5.5);
      var glow = Math.max(0.4, 5.5 - dist * 0.45);

      var p = document.createElement('div');
      p.className = 'particle';
      p.style.cssText = 'left:' + (col*GAP) + 'rem;top:' + (row*GAP) + 'rem;transform:scale(' + scale + ');opacity:' + opacity + ';background:hsl(196,92%,' + light + '%);box-shadow:0 0 ' + (glow*0.22).toFixed(2) + 'rem 0 hsl(196,92%,58%);mix-blend-mode:screen;';
      grid.appendChild(p);
      particles.push({ el: p, dist: dist, scale: scale });
    }

    function move() {
      particles.forEach(function(item) {
        var d = Math.max(0.3, 1 - item.dist * 0.08);
        item.el.style.transition = 'transform ' + (120 + item.dist*20) + 'ms cubic-bezier(0.25,0.46,0.45,0.94)';
        item.el.style.transform  = 'translate(' + (cursor.x*d).toFixed(1) + 'px,' + (cursor.y*d).toFixed(1) + 'px) scale(' + item.scale + ')';
      });
    }

    function tick() {
      var t = (Date.now() - startTime) * 0.001;
      if (isAuto) {
        cursor.x = Math.sin(t*0.3)*200 + Math.sin(t*0.17)*100;
        cursor.y = Math.cos(t*0.2)*150 + Math.cos(t*0.23)*80;
      } else if (isStatic) {
        var age = Date.now() - lastMove;
        if (age > 200) {
          var s = Math.min((age - 200) / 1000, 1);
          cursor.x = staticCur.x + Math.sin(t*1.5)*20*s;
          cursor.y = staticCur.y + Math.cos(t*1.2)*16*s;
        }
      }
      move();
      raf = requestAnimationFrame(tick);
    }
    tick();

    hero.addEventListener('mousemove', function(e) {
      var cx = window.innerWidth/2, cy = window.innerHeight/2;
      cursor.x = staticCur.x = (e.clientX - cx) * 0.8;
      cursor.y = staticCur.y = (e.clientY - cy) * 0.8;
      isAuto = false; isStatic = false; lastMove = Date.now();
      clearTimeout(mTimer);
      mTimer = setTimeout(function() { isStatic = true; }, 500);
      setTimeout(function() {
        if (Date.now() - lastMove >= 4000) { isAuto = true; isStatic = false; startTime = Date.now(); }
      }, 4000);
    });
    hero.addEventListener('mouseleave', function() {
      setTimeout(function() { isAuto = true; isStatic = false; startTime = Date.now(); }, 2000);
    });

    /* Shopify editor cleanup */
    section._purposeParticleCleanup = function() {
      cancelAnimationFrame(raf);
      clearTimeout(mTimer);
    };
  }

  /* Init on page load */
  document.addEventListener('DOMContentLoaded', function() {
    var hero = document.querySelector('[data-section-type="purpose-hero"]');
    if (hero) initParticles(hero);
  });

  /* Shopify theme editor events */
  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.querySelector('[data-section-type="purpose-hero"]')) {
      initParticles(e.target.querySelector('[data-section-type="purpose-hero"]'));
    }
  });
  document.addEventListener('shopify:section:unload', function(e) {
    var hero = e.target.querySelector('[data-section-type="purpose-hero"]');
    if (hero && hero._purposeParticleCleanup) hero._purposeParticleCleanup();
  });
})();
